// extracted by mini-css-extract-plugin
export var activeItem = "Categories-module--active-item--c594e";
export var closeButton = "Categories-module--close-button--aee2e";
export var curtain = "Categories-module--curtain--d8f74";
export var item = "Categories-module--item--f176a";
export var modal = "Categories-module--modal--3afe4";
export var modalWrapper = "Categories-module--modal-wrapper--f73c3";
export var nav = "Categories-module--nav--53e5c";
export var root = "Categories-module--root--029c1";
export var toggle = "Categories-module--toggle--c6d1c";
export var xIcon = "Categories-module--x-icon--14b70";